import React from 'react'

export default class IconsMainNavTemplates extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path d='M2 6H14' stroke='#646464' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M6 14V6' stroke='#646464' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
        )
    }
}
